// EWM-443 — the cart icon badge caps its label at "99+" so a large
// line-item count can't overflow the badge. Counts of 99 or fewer show
// as-is; anything above shows "99+".
const MAX_BADGE_COUNT = 99;

const formatCartBadge = (count: number): string => (count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : `${count}`);

export default formatCartBadge;
